module.exports = __webpack_public_path__ + "media/images/icon__minus@3x-767bdfba3dae27eab719d4ac0abc2974.png";